import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Login from "./components/views/Login";
import Dashboard from "./components/views/Dashboard";
import ProfitAndLoss from "./components/views/Master/Profit And Loss/ProfitAndLoss";
import AccountList from "./components/views/AccountList";
import Bank from "./components/views/Bank";
import BankUpdate from "./components/views/AccountData/Bank/BankUpdate.jsx";
import Currency from "./components/views/Currency";
import Income from "./components/views/Income";
import IncomeUpdate from "./components/views/AccountData/Income/IncomeUpdate.jsx";
import IncomeType from "./components/views/IncomeType";
import Expense from "./components/views/Expense";
import ExpenseUpdate from "./components/views/AccountData/Expense/ExpenseUpdate.jsx";
import ExpenseType from "./components/views/ExpenseType";
import FixAsset from "./components/views/FixAsset";
// import ProfitLoss from './components/views/ProfitLoss'
import BalanceSheet from "./components/views/BalanceSheet";
import TrialBabl from "./components/views/TrailBabl";
import MedicineSale from "./components/views/MedicineSale";
// import Treatment from './components/views/Treatment'
import AccountType from "./components/views/AccountType";
import Heading from "./components/views/Heding";
import SubHeader from "./components/views/SubHeader";
import Category from "./components/views/Master/Category";
import SubCategory from "./components/views/Master/SubCategory";
import Brand from "./components/views/Master/Brand";
import AddAsset from "./components/views/AddAsset";
import MedicineList from "./components/views/Master/MedicineList/MedicineList";
import Unit from "./components/views/Master/MedicineList/Unit";
import ProcedureMedicine from "./components/views/Master/Procedure Medicine/ProcedureMedicine";
import ProUnit from "./components/views/Master/Procedure Medicine/ProUnit";
import StockCount from "./components/views/StockCount";
import StockHistory from "./components/StockHistory.jsx";
import StockUnit from "./components/views/StockUnit";
import StockMedUnit from "./components/views/StockMedUnit";
import PurchaseDetail from "./components/views/PurchaseDetail";
import PurchaseAdd from "./components/views/PurchaseAdd";
import StockProAss from "./components/views/StockProAssUnit";
import TreatmentCreate from "./components/views/Master/Treatment/TreatmentCreate";
import CheckUnit from "./components/views/Master/Treatment/CheckUnit";
import SellEndDialog from "./components/views/SellEndDialog";
import Supplier from "./components/views/Supplier";
import CreditDetail from "./components/views/CreditDetail";
import MedicineUpdate from "./components/views/Master/MedicineList/MedicineUpdate";
import TreatmentSale from "./components/views/TreatmentSale";
import AccListUpdate from "./components/views/AccListUpdate";
import ProUpdate from "./components/views/Master/Procedure Medicine/ProUpdate.jsx";
import TreatUpdate from "./components/views/Master/Treatment/Update.jsx";
import TCheckList from "./components/views/Master/Treatment/UnitCreate.jsx";
// import UnitUpdate from './components/views/Master/Treatment/UnitUpdate.jsx'
import ProcedureAccessory from "./components/views/Master/ProAccess/ProAccess";
import ProAccessUpdate from "./components/views/Master/ProAccess/ProUpdate.jsx";
import ProAccessUnit from "./components/views/Master/ProAccess/ProAccessUnit";
import TransferList from "./components/views/Master/Transfer/TransferList";
// import TransactionList from './components/views/Master/Transaction/TransactionList';
import StockList from "./components/views/Master/Log/LogList";
import Update2 from "./components/views/Master/Treatment/UnitUpdate2";
import Doctor from "./components/views/Admin/Doctor/DoctorList.jsx";
import DoctorReg from "./components/views/Admin/Doctor/Register.jsx";
import DoctorUpdate from "./components/views/Admin/Doctor/DoctorUpdate.jsx";
import DoctorCommission from "./components/views/Admin/Doctor/Commission.jsx";

import AllTran from "./components/views/Master/Transaction/AllTransaction.jsx";
import StockRequest from "./components/views/Admin/StockRequest/StockRequestList.jsx";
import StockReqCreate from "./components/views/Admin/StockRequest/StockRequestCreate.jsx";
import SQUpdate from "./components/views/Admin/StockRequest/SQUpdate.jsx";
import StockTran from "./components/views/Admin/StockTransfer/StockTransferList.jsx";
import StockTranCreate from "./components/views/Admin/StockTransfer/StockTranCreate.jsx";
import STUpdate from "./components/views/Admin/StockTransfer/StockTranUpdate";
import ShowPrint from "./components/views/Admin/StockRequest/ShowPrint.jsx";
import STPrint from "./components/views/Admin/StockTransfer/TShowPrint.jsx";
import JournalEntry from "./components/views/AccountData/JournalEntryList.jsx";
import JournalUpdate from "./components/views/AccountData/JournalEntry/JEUpdate.jsx";
import Machine from "./components/views/Master/Machine/Machine.jsx";
import Discount from "./components/views/Admin/Discount/DiscountList.jsx";
import Member from "./components/views/Admin/Member/MemberList.jsx";
import ReOrderList from "./components/views/Admin/Reorder/ReorderList.jsx";
import Package from "./components/views/Admin/PackageList/PackageList.jsx";
import PackageReg from "./components/views/Admin/PackageList/PackageReg.jsx";
import PackageUpdate from "./components/views/Admin/PackageList/PackageUpdate.jsx";
import SaleReturn from "./components/views/Admin/SaleReturn/SaleReturnList.jsx";
import Top10 from "./components/views/Admin/Top10/Top10List.jsx";
import Advance from "./components/views/Admin/Advance/AdvanceList.jsx";
import UserList from "./components/views/Admin/User/UserList.jsx";
import UserDetail from "./components/views/Admin/User/UserDetail.jsx";
import PurchaseAddFromReOder from "./components/views/Admin/PurchaseFormReOrder/AddPurchase";
import BCReport from "./components/views/AccountData/BCReport/bcreport.jsx";
import AccReport from "./components/views/AccountData/AccountReport/AccountReport.jsx";
import General from "./components/views/Master/General Item/General.jsx";
import GeneralItems from "./components/views/Master/General Item/GeneralItems.jsx";
import GeneralUpdate from "./components/views/Master/General Item/GeneralUpdate.jsx";
import PurchaseReceived from "./components/views/Admin/Purchase/PurchaseReceived.jsx";
import PurchaseTransfer from "./components/views/Admin/Purchase/PurchaseTransfer.jsx";
import PurchaseTransferList from "./components/views/Admin/Purchase/PurchaseTranList.jsx";
import MemberUpdate from "./components/views/Admin/Member/MemberUpdate.jsx";
import ApproveDetail from "./components/views/Admin/Purchase/PurApproveDetail.jsx";
import DisUpdate from "./components/views/Admin/Discount/DisUpdate.jsx";
import Customer from "./components/views/Admin/Customer/customerList.jsx";
import NurComission from "./components/views/Admin/Doctor/NurCom.jsx";
import TheComission from "./components/views/Admin/Doctor/TheCommission.jsx";
import KMax from "./components/views/Admin/KMax/kmax.jsx";
import ExpDateList from "./components/views/Admin/ExpiredDateList/expDateList.jsx";
import ExpDateListDetail from "./components/views/Admin/ExpiredDateList/detailItems.jsx";
import TransferReport from "./components/views/AccountData/transferReportList.jsx";
import IssueToHO from "./components/views/Admin/IssueHO/issue_to_ho_create.jsx";
import IssueList from "./components/views/Admin/IssueHO/issue_to_ho_list.jsx";
import IssueDetail from "./components/views/Admin/IssueHO/issue_to_ho_detail.jsx";
import ReceiveFromPOS from "./components/views/Admin/ReceiveFromPOS/receiveList.jsx";
// import Print from './components/views/AccountData/AccountReport/Print.jsx'

import DentalTreatment from "./components/views/Master/Dental Treatment/dental_treatment_list.jsx";
import DentalCheckUnit from "./components/views/Master/Dental Treatment/dental_checkunit.jsx";
import DentalCheckUnitCreate from "./components/views/Master/Dental Treatment/dental_unit_create.jsx";
import DentalCheckUnitUpdate from "./components/views/Master/Dental Treatment/dental_unit_update.jsx";
import DentalUpdate from "./components/views/Master/Dental Treatment/dental_update.jsx";

// website dashboard start

//Treatment
import WebDashboard from "./components/views/website-dashboard/main.jsx";
import WebTreatmentCreate from "./components/views/website-dashboard/treatment/treatment_pages/treatmentCreatePage.jsx";
import WebTreatmentUpdate from "./components/views/website-dashboard/treatment/treatment_pages/treatmentUpdatePage.jsx";

// Promotion
import Promotion from "./components/views/website-dashboard/promotion/promo_pages/promo_list.jsx";
import PromotionCreate from "./components/views/website-dashboard/promotion/promo_pages/promo_create_page.jsx";
import PromotionUpdate from "./components/views/website-dashboard/promotion/promo_pages/promo.update_page.jsx";

//Banner
import Banner from "./components/views/website-dashboard/banner/banner_pages/banner_list_page.jsx";
import BannerCreate from "./components/views/website-dashboard/banner/banner_pages/banner_create_page.jsx";
import BannerUpdate from "./components/views/website-dashboard/banner/banner_pages/banner_update_page.jsx";

//Notfound

import NotFound from "./components/views/404NotFound.js";
//Website dashboard end
import "./App.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.min.js";
import "./components/views/Nav/ShowHideSideBar.jsx";
import "./assets/dist/css/adminlte.min.css";
import "./plugins/fontawesome-free/css/all.min.css";
import "./plugins/tempusdominus-bootstrap-4/css/tempusdominus-bootstrap-4.min.css";
import "./plugins/icheck-bootstrap/icheck-bootstrap.min.css";
import "./plugins/jqvmap/jqvmap.min.css";
import "react-bootstrap-typeahead/css/Typeahead.css";

import "./plugins/overlayScrollbars/css/OverlayScrollbars.min.css";
import "./plugins/daterangepicker/daterangepicker.css";
import "./plugins/summernote/summernote-bs4.css";
import "./plugins/select2/css/select2.min.css";
import "./file.css";
import "./plugins/select2-bootstrap4-theme/select2-bootstrap4.min.css";
import "./assets/plugins/multiselect/css/multi-select.css";
import "./plugins/datatables-bs4/css/dataTables.bootstrap4.css";
import "./assets/plugins/dropify/dist/css/dropify.min.css";
import "./assets/plugins/bootstrap-datepicker/bootstrap-datepicker.min.css";
import "./assets/plugins/bootstrap-material-datetimepicker/css/bootstrap-material-datetimepicker.css";
import UnitConvention from "./components/views/Master/UnitConvention/unitConvention.jsx";
import ProductItem from "./components/views/Admin/ProductItem/ProductItem.jsx";
import ProductItemUnit from "./components/views/Admin/ProductItemUnit/ProductItemUnit.jsx";
import PurchaseCreatePage from "./components/views/Admin/PurchaseRequest/PurchaseCreatePage.jsx";
import Purchase from "./components/views/Admin/PurchaseRequest/Purchase.jsx";
import PurchaseRequestDetail from "./components/views/Admin/PurchaseRequest/PurchaseRequestDetail.jsx";
import PurchaseVoucher from "./components/views/Admin/PurchaseVoucher/PurchaseVoucher.jsx";
import StockCountAndPrice from "./components/views/Admin/StockCountAndPrice/StockCountAndPrice.jsx";
import StockHistoryList from "./components/views/Admin/StockHistory/StockHistory.jsx";

function App() {
  const Role = localStorage.getItem("role");

  return (
    <div>
      <Router>
        <Routes>
          <Route path="/dash" element={<Dashboard />}></Route>
          <Route path="/" element={<Login />}></Route>
          {Role === "Website" ? (
            <>
              <Route path="/" element={<Login />}></Route>
              {/* Treatment */}
              <Route
                path="/treatment-dashboard"
                element={<WebDashboard />}
              ></Route>
              <Route
                path="/treatment-create"
                element={<WebTreatmentCreate />}
              ></Route>
              <Route
                path="/treatment-update/:id"
                element={<WebTreatmentUpdate />}
              ></Route>

              {/* Promotion */}
              <Route path="/promotion" element={<Promotion />}></Route>
              <Route
                path="/promotion-create"
                element={<PromotionCreate />}
              ></Route>
              <Route
                path="/promotion-update/:id"
                element={<PromotionUpdate />}
              ></Route>

              {/* Banner */}
              <Route path="/banner" element={<Banner />}></Route>
              <Route path="/banner-create" element={<BannerCreate />}></Route>
              <Route
                path="/banner-update/:id"
                element={<BannerUpdate />}
              ></Route>
            </>
          ) : Role === "Admin" ? (
            <>
              {/* <Route path='/transaction-list' element={<TransactionList />}></Route> */}
              <Route
                path="/profit-and-loss"
                element={<ProfitAndLoss />}
              ></Route>
              <Route path="/stock-list" element={<StockList />}></Route>
              <Route path="/transfer-list" element={<TransferList />}></Route>
              <Route path="/fix_asset" element={<FixAsset />}></Route>
              <Route path="/sellEnd/:id" element={<SellEndDialog />}></Route>
              <Route path="/expense" element={<Expense />}></Route>;
              <Route
                path="/expense-update/:expenseid"
                element={<ExpenseUpdate />}
              ></Route>
              <Route path="/expense_type" element={<ExpenseType />}></Route>
              <Route path="/income" element={<Income />}></Route>
              <Route
                path="/income-update/:incomeid"
                element={<IncomeUpdate />}
              ></Route>
              <Route path="/income_type" element={<IncomeType />}></Route>
              <Route path="/currency" element={<Currency />}></Route>
              <Route path="/bank" element={<Bank />}></Route>
              <Route
                path="/bank-update/:bankid"
                element={<BankUpdate />}
              ></Route>
              <Route path="/account_list" element={<AccountList />}></Route>
              {/* <Route path='/profit_loss' element={<ProfitLoss />}></Route> */}
              <Route path="/balance_sheet" element={<BalanceSheet />}></Route>
              <Route path="/trail_bal" element={<TrialBabl />}></Route>
              <Route path="/medicineSale" element={<MedicineSale />}></Route>
              {/* <Route path='/treatment' element={<Treatment />}></Route> */}
              <Route path="/acc_type" element={<AccountType />}></Route>
              <Route path="/head" element={<Heading />}></Route>
              <Route path="/subHead" element={<SubHeader />}></Route>
              <Route path="/category" element={<Category />}></Route>
              <Route path="/sub_category" element={<SubCategory />}></Route>
              <Route path="/brand" element={<Brand />}></Route>
              <Route path="/add_asset" element={<AddAsset />}></Route>
              <Route path="/product_list" element={<MedicineList />}></Route>
              <Route path="/medUp/:id" element={<MedicineUpdate />}></Route>
              {/* <Route path="/unit/:id" element={<Unit />}></Route> */}
              <Route path="/unit/:id" element={<ProductItem />}></Route>
              <Route
                path="/product-item/unit/:id"
                element={<ProductItemUnit />}
              ></Route>
              <Route
                path="/pro_medicine"
                element={<ProcedureMedicine />}
              ></Route>
              <Route path="/prounit/:id" element={<ProUnit />}></Route>
              <Route path="/stock" element={<StockCount />}></Route>
              <Route path="/stock-history" element={<StockHistory />}></Route>
              <Route path="/stockUnit/:id" element={<StockUnit />}></Route>
              <Route path="/stockMed/:id" element={<StockMedUnit />}></Route>
              <Route path="/stockProAss/:id" element={<StockProAss />}></Route>
              {/* <Route path="/purchase" element={<Purchase />}></Route> */}
              <Route path="/purchase" element={<Purchase />}></Route>
              <Route
                path="/purchaseDetail/:id"
                element={<PurchaseDetail />}
              ></Route>
              {/* <Route path="/add_purchase" element={<PurchaseAdd />}></Route> */}
              <Route path="/add_purchase" element={<PurchaseCreatePage />} />
              <Route path="/purchase/:id" element={<PurchaseRequestDetail />} />
              <Route path="/purchase-voucher" element={<PurchaseVoucher />} />
              <Route
                path="stock-count-price"
                element={<StockCountAndPrice />}
              />
              {/* stock history list */}
              <Route path="/stock-history-list" element={<StockHistoryList />} />
              <Route path="/treatC" element={<TreatmentCreate />}></Route>
              <Route path="/checkUnit/:id" element={<CheckUnit />}></Route>
              <Route path="/supplier" element={<Supplier />}></Route>
              <Route
                path="/creditDetail/:id"
                element={<CreditDetail />}
              ></Route>
              <Route path="/treatSale" element={<TreatmentSale />}></Route>
              <Route path="/accUpdate/:id" element={<AccListUpdate />}></Route>
              <Route path="/proUpdate/:id" element={<ProUpdate />}></Route>
              <Route path="/treatUpdate/:id" element={<TreatUpdate />}></Route>
              <Route path="/TCL/:id" element={<TCheckList />}></Route>
              <Route path="/unitUpdate/:id1/:id2" element={<Update2 />}></Route>
              <Route
                path="/pro-access"
                element={<ProcedureAccessory />}
              ></Route>
              <Route
                path="/proAcessUpdate/:id"
                element={<ProAccessUpdate />}
              ></Route>
              <Route
                path="/proAccessUnit/:id"
                element={<ProAccessUnit />}
              ></Route>
              <Route path="/doctor" element={<Doctor />}></Route>
              <Route path="/doctor-reg" element={<DoctorReg />}></Route>
              <Route
                path="/dnt-update/:doctorid"
                element={<DoctorUpdate />}
              ></Route>
              <Route
                path="/refDoctor/:doctorid"
                element={<DoctorCommission />}
              ></Route>
              <Route path="/all-tran" element={<AllTran />}></Route>
              <Route path="/stock-req" element={<StockRequest />}></Route>
              <Route
                path="/stock-req-create"
                element={<StockReqCreate />}
              ></Route>
              <Route path="/sq-Update/:id" element={<SQUpdate />}></Route>
              <Route
                path="/show-print/:printid"
                element={<ShowPrint />}
              ></Route>
              <Route path="/stock-tran" element={<StockTran />}></Route>
              <Route
                path="/stock-tran-create/:id"
                element={<StockTranCreate />}
              ></Route>
              <Route path="/st-update/:id" element={<STUpdate />}></Route>
              <Route path="/show-tran-print/:id" element={<STPrint />}></Route>
              <Route path="/journal-list" element={<JournalEntry />}></Route>
              <Route
                path="/je-update/:jeid"
                element={<JournalUpdate />}
              ></Route>
              <Route path="/machine" element={<Machine />}></Route>
              <Route path="/discount" element={<Discount />}></Route>
              <Route path="/dis-update/:id" element={<DisUpdate />}></Route>
              <Route path="/member" element={<Member />}></Route>
              <Route path="/mem-update/:id" element={<MemberUpdate />}></Route>
              <Route path="/reorder" element={<ReOrderList />}></Route>
              <Route path="/package" element={<Package />}></Route>
              <Route path="/packageReg" element={<PackageReg />}></Route>
              <Route
                path="/package-update/:packageid"
                element={<PackageUpdate />}
              ></Route>
              <Route path="/sale-return" element={<SaleReturn />}></Route>
              <Route path="/top10" element={<Top10 />}></Route>
              <Route path="/advance" element={<Advance />}></Route>
              <Route path="/user" element={<UserList />}></Route>
              <Route path="/unit-con" element={<UnitConvention />}></Route>
              <Route path="/user-detail/:id" element={<UserDetail />}></Route>
              <Route
                path="/add_purchase_reOrder/:data"
                element={<PurchaseAddFromReOder />}
              ></Route>
              <Route path="/bc-report" element={<BCReport />}></Route>
              <Route path="/acc-report" element={<AccReport />}></Route>
              <Route path="/gen" element={<General />}></Route>
              <Route
                path="/general-item/:id"
                element={<GeneralItems />}
              ></Route>
              <Route path="/gen-update/:id" element={<GeneralUpdate />}></Route>
              <Route path="/pur-rec/:id" element={<PurchaseReceived />}></Route>
              <Route
                path="/pur-tran/:id"
                element={<PurchaseTransfer />}
              ></Route>
              <Route
                path="/appr-detail/:id"
                element={<ApproveDetail />}
              ></Route>
              <Route
                path="/pur-tranlist"
                element={<PurchaseTransferList />}
              ></Route>
              <Route path="/customer" element={<Customer />}></Route>
              <Route path="/refthe/:id" element={<TheComission />}></Route>
              <Route path="/refnur/:id" element={<NurComission />}></Route>
              <Route path="/knas" element={<KMax />}></Route>
              <Route path="/expDateList" element={<ExpDateList />}></Route>
              <Route
                path="/expDetail/:id"
                element={<ExpDateListDetail />}
              ></Route>
              <Route
                path="/transferreport-list"
                element={<TransferReport />}
              ></Route>
              <Route path="/issue-ho" element={<IssueToHO />}></Route>
              <Route path="/issue-list" element={<IssueList />}></Route>
              <Route path="/issue_detail/:id" element={<IssueDetail />}></Route>
              <Route path="/receive-pos" element={<ReceiveFromPOS />}></Route>
              {/* Dental Treatment */}
              <Route
                path="/dental-treatment"
                element={<DentalTreatment />}
              ></Route>
              <Route
                path="/dental-update/:id"
                element={<DentalUpdate />}
              ></Route>
              <Route
                path="/dental-check/:id"
                element={<DentalCheckUnit />}
              ></Route>
              <Route
                path="/dental-check-create/:id"
                element={<DentalCheckUnitCreate />}
              ></Route>
              <Route
                path="/dental-check-update/:id1/:id2"
                element={<DentalCheckUnitUpdate />}
              ></Route>
            </>
          ) : (
            <>
              <Route path="/404" element={<NotFound />}></Route>
            </>
          )}
        </Routes>
      </Router>
    </div>
  );
}
export default App;
